import "./body.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-regular-svg-icons";
import Resume from "../../assets/CV_8Yrs.pdf";

export const Body = () => {
  const resumeDownload = () => {
    const link = document.createElement("a");
    link.href = Resume;
    link.setAttribute("download", "Ratan's resume.pdf");
    link.click();
  };

  return (
    <div className="body">
      <p className="first-line">Hello, this is Ratan</p>
      <hr className="first-line-hr" />
      <h1 className="body-content-one">I am a React developer</h1>
      <p className="body-content-two">
        with overall of about 8+ years of experience
      </p>
      <p className="body-content-three">in the IT industry. </p>
      <p className="body-content-two">
        You can download my CV to know more about me and what I can bring to the
        table.
      </p>
      <p className="body-content-four">
        This is my portfolio and it is built with
      </p>
      <h1 className="body-content-five">React js. </h1>
      <FontAwesomeIcon
        icon={faFilePdf}
        className="body-envelope"
        onClick={resumeDownload}
      />
    </div>
  );
};
